import { useTranslation } from 'react-i18next';

import CertificationModuleLoadingSkeleton from '../../../scenes/CertificationModule/components/CertificationModuleLoadingSkeleton';
import CertificationProcessLoadingSkeleton from '../../../scenes/CertificationProcess/components/CertificationProcessLoadingSkeleton';
import CertificationQuizLoadingSkeleton from '../../../scenes/CertificationQuiz/components/CertificationQuizLoadingSkeleton';
import CertificationLoadingSkeleton from '../../../scenes/Certifications/components/CertificationLoadingSkeleton';
import ContractSigningLoadingSkeleton from '../../../scenes/ContractSigning/components/ContractSigningLoadingSkeleton';
import HomeLoadingSkeleton from '../../../scenes/Home/components/HomeLoadingSkeleton';
import MyContractLoadingSkeleton from '../../../scenes/MyContract/components/MyContractLoadingSkeleton';
import MyTaskDetailLoadingSkeleton from '../../../scenes/MyTaskDetails/components/MyTaskDetailLoadingSkeleton';
import MyTasksLoadingSkeleton from '../../../scenes/MyTasks/components/MyTasksLoadingSkeleton';
import IdentityVerificationLoadingSkeleton from '../../../scenes/NewIdentityVerification/components/IdentityVerificationLoadingSkeleton';
import { getAppUrl } from '../../../utils/utils';
import LoadingSpin from '../LoadingSpin/LoadingSpin';

import './LoadingScreen.scss';

const LoadingScreen = () => {
  const { t } = useTranslation();
  const BASE_APP_URL = getAppUrl();
  const URL = window.location.href;

  const ConditionalLoadingScreen = (): JSX.Element => {
    const conditionalUrl = `${BASE_APP_URL}`;

    if (
      URL.toLowerCase() === `${conditionalUrl}/certifications`.toLowerCase() ||
      URL.toLowerCase() === `${conditionalUrl}/certifications/`.toLowerCase()
    ) {
      return <CertificationLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(
        `${conditionalUrl}/certifications`.toLowerCase()
      )
    ) {
      return <CertificationProcessLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(
        `${conditionalUrl}/certification-modules`.toLowerCase()
      )
    ) {
      return <CertificationModuleLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(
        `${conditionalUrl}/certification-quizzes`.toLowerCase()
      )
    ) {
      return <CertificationQuizLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(
        `${conditionalUrl}/my-contract/identity-verification`.toLowerCase()
      )
    ) {
      return <IdentityVerificationLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(
        `${conditionalUrl}/my-contract/contract-signing`.toLowerCase()
      )
    ) {
      return <ContractSigningLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(
        `${conditionalUrl}/my-contract`.toLowerCase()
      )
    ) {
      return <MyContractLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(`${conditionalUrl}/home`.toLowerCase())
    ) {
      return <HomeLoadingSkeleton />;
    } else if (
      URL.toLowerCase() === `${conditionalUrl}/my-tasks`.toLowerCase() ||
      URL.toLowerCase() === `${conditionalUrl}/my-tasks/`.toLowerCase()
    ) {
      return <MyTasksLoadingSkeleton />;
    } else if (
      URL.toLowerCase().startsWith(`${conditionalUrl}/my-tasks`.toLowerCase())
    ) {
      return <MyTaskDetailLoadingSkeleton />;
    } else {
      return <LoadingSpin loading />;
    }
  };

  return <ConditionalLoadingScreen />;
};

export default LoadingScreen;
